import { SystemIcon } from '@storeblocks/icon';
import styled from 'styled-components';

export const CheckIcon = styled(SystemIcon).attrs(() => ({
  name: 'check',
  size: 16,
  isPhosphor: true,
}))``;
